export { stripDiacritics } from './Diacritics';